import { Outlet } from "react-router-dom";
import Header from "../../../components/header/Header";
import "../defaultLayout/DefaultLayout.css"
import AdminSidebar from "../../sidebar/adminSidebar/AdminSidebar";

export function AdminLayout(){
   
    return (
        <div>
            <Header title='Wisdom Dashboard'/>
            <div className="layout-container">
                <AdminSidebar />
                <div className="layout-outlet">
                    <Outlet />
                </div>
            </div>
        </div>
    )
}